import { AddOnsByType, IAddon, IAddOnAxes } from "./types";

/** mirrors harbormaster's `select-matching-addons`: deployment, then term */
export const isOfferedOn =
  ({ isCloudHosted, isYearly }: IAddOnAxes) =>
  ({ deployment, billing_period_months, is_metered }: IAddon): boolean =>
    (deployment === "all" ||
      deployment === (isCloudHosted ? "hosting" : "selfhosted")) &&
    // metered add-ons bill monthly whatever the plan's term, so they carry
    // no yearly row and must not be filtered out on a yearly plan
    (!!is_metered || billing_period_months === (isYearly ? 12 : 1));

export function indexAddOnsByType(
  addOns: IAddon[],
  axes: IAddOnAxes,
): AddOnsByType {
  const byType: AddOnsByType = {};

  addOns.filter(isOfferedOn(axes)).forEach((row) => {
    byType[row.product_type] = row;
  });

  return byType;
}
